export const dashboardImages = {
  reset_icon: 'assets/img/dash/svg/rest.svg',
  add_icon: 'assets/img/dash/svg/add.svg',
  remove_icon: 'assets/img/dash/svg/minus.svg',
  like_icon: 'assets/img/dash/like.svg',
  heart_icon: 'assets/img/dash/heart.svg',
  comment_icon: 'assets/img/dash/comment.svg',
  send_icon: 'assets/img/dash/send.svg',
  link_icon: 'assets/img/dash/svg/link.svg',
  map_icon: 'assets/img/dash/svg/map.svg',
  email_icon: 'assets/img/dashboadIcon/email.svg',
  follow_icon: 'assets/img/dash/svg/follow.svg',
  lead_icon: 'assets/img/dash/svg/leads.svg',
  contract_icon: 'assets/img/dash/svg/contract.svg',
  ofi_icon: 'assets/img/dash/svg/ofis.svg',
  report_img: 'assets/img/dash/report.png',
  report_icon: 'assets/img/dash/svg/rep.svg',
  dash_report: 'assets/img/dash/svg/report.svg',
  drop_icon: 'assets/img/dash/drop.svg',
  eoi_icon: 'assets/img/dash/svg/eoi.svg',
  market_icon: 'assets/img/dash/svg/market.svg',
  listing_icon: 'assets/img/dash/svg/listing.svg',
  task_icon: 'assets/img/dash/svg/tasks.svg',
  matrix_icon: 'assets/img/dash/svg/matrix.svg',
  project_icon: 'assets/img/dash/svg/project.svg',
  price_list_icon: 'assets/img/dash/svg/price_list.svg',
  sale_icon: 'assets/img/dash/svg/sales.svg',
  building_icon: 'assets/img/dash/building.png',
  weather_icon: 'assets/img/dash/svg/weather.svg',
  notice_board_icon: 'assets/img/dash/svg/notice board.svg',
  email_icon_v2: 'assets/img/dash/svg/email.svg',
  banner_icon: 'assets/img/dash/svg/banner.svg',
  appraisal_icon: 'assets/img/dash/svg/appraisal.svg',
  property_icon: 'assets/img/dash/svg/property.svg',
};
